import script from "./ActionsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionsMenu.vue?vue&type=script&setup=true&lang=js"

import "./ActionsMenu.vue?vue&type=style&index=0&id=7dc8888e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dc8888e"]])

export default __exports__